import { render, staticRenderFns } from "./SectorsAssociation.vue?vue&type=template&id=70edd3ef&"
import script from "./SectorsAssociation.vue?vue&type=script&lang=js&"
export * from "./SectorsAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports